var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-item',[_c('core-card-foot-item-value',{staticClass:"count-wrapper"},[_c('app-game-item-field-count',{attrs:{"item":_vm.item,"format":_vm.format}})],1),_c('core-card-foot-item-label',[_vm._v(" Players ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }